<div class="tw:w-full tw:p-0 tw:m-0">

  <!-- Learner creation (Upload + Manual) suppressed: Orbit is the source of record for learners
       (bug 37289 §7a). Learners are created in Orbit and synced into LEAP; this screen is retired.
       The buttons are kept behind @if(false) so the flow is recoverable if the policy changes. -->
  <div class="tw:flex tw:flex-wrap tw:px-0 tw:pb-6 tw:pt-6 tw:mx-0 tw:my-2 tw:justify-center">
    <div class="tw:w-full tw:px-[15px] tw:text-center">
      Learners are now created in Orbit and appear here automatically. To add a learner, create them in Orbit.
    </div>

    @if (false) {
      <div class="tw:w-1/2 tw:px-[15px] tw:lg:w-1/4">
        <button type="button" #uploadButton
          class="btn btn-outline-primary btn-lg tw:block tw:w-full btn-huge btn-add-student-mode-selector"
        (click)="setMode('Upload')">Upload</button>
      </div>
      <div class="tw:w-1/2 tw:px-[15px] tw:lg:w-1/4">
        <button type="button" #manualButton
          class="btn btn-outline-primary btn-lg tw:block tw:w-full btn-huge btn-add-student-mode-selector"
        (click)="setMode('Manual')">Manual</button>
      </div>
    }
  </div>

</div>

